import { render, staticRenderFns } from "./coins.vue?vue&type=template&id=1f6ecb85&scoped=true"
import script from "./coins.vue?vue&type=script&lang=js"
export * from "./coins.vue?vue&type=script&lang=js"
import style0 from "./coins.vue?vue&type=style&index=0&id=1f6ecb85&prod&lang=scss&scoped=true"
import style1 from "./coins.vue?vue&type=style&index=1&id=1f6ecb85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ecb85",
  null
  
)

export default component.exports